import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  TimePicker,
  Switch,
  Select,
  message,
} from "antd";
import get from "lodash/get";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import moment from "moment-timezone";

import {
  datafaxPullGet,
  datafaxPullTest,
  datafaxPullUpdate,
  datafaxPullActivate,
  datafaxPullDeactivate,
} from "../../api/requests";

import classes from "./DatafaxForms.css";
import {
  getUserTimezone,
  getUserShortTimezone,
  getApiDatafaxCreatePermission,
  getApiDatafaxUpdatePermission,
  getApiDatafaxDeletePermission,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const timezones = require("../../utils/timezones.json");

const { Option } = Select;

class DatafaxPullForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingData: true,
      isLoading: false,
      isLoadingTest: false,
      requestResult: {},
      schedule: {},
      test: {},
      shortTz: get(
        find(timezones, ({ utc }) => utc.includes(this.props.time_zone)),
        "abbr",
        ""
      ),
    };
  }

  async componentDidMount() {
    // this.getStatus();

    await this.getSchedule();

    this.setState({ isLoadingData: false });
  }

  async getSchedule() {
    try {
      const { data } = await datafaxPullGet();
      this.setState({ schedule: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  async getStatus() {
    this.setState({ isLoadingTest: true });
    try {
      const { data } = await datafaxPullTest();
      this.setState({ test: data });
    } catch (e) {
      this.setState({ test: { error: get(e, "response.data.error.message", "") } });
    }

    this.setState({ isLoadingTest: false });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.props.apiDatafaxCreatePermission) {
      return;
    }

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        const scheduled = cloneDeep(values);
        if (values.scheduled_time_1) {
          scheduled.scheduled_time_1 = cloneDeep(
            values.scheduled_time_1
          ).format("HH:mm:ss");
        }
        if (values.scheduled_time_2) {
          scheduled.scheduled_time_2 = cloneDeep(
            values.scheduled_time_2
          ).format("HH:mm:ss");
        }
        if (!values.time_zone) {
          scheduled.time_zone = null;
        }

        try {
          await datafaxPullUpdate({ ...scheduled });
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
            test: {},
          });

          this.getStatus();
          this.getSchedule();

          // setTimeout(() => {
          //   this.props.onSubmit(this.props.id);
          // }, 2200);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onSwitchActivation = (state) => async () => {
    this.setState({ isLoading: true });

    try {
      if (state === "active") {
        await datafaxPullDeactivate();
      } else {
        await datafaxPullActivate();
      }

      message.success(this.props.i18n.t("Saved"));

      await this.getSchedule();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
    }

    this.setState({ isLoading: false });
  };

  /*onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '') || [null, null];
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };*/

  render() {
    const {
      isLoading,
      requestResult,
      isLoadingData,
      isLoadingTest,
      test,
      schedule,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      apiDatafaxCreatePermission,
      apiDatafaxUpdatePermission,
      apiDatafaxDeletePermission,
    } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceScheduleUploadForm:Update Data from DFDiscover"
            )}
            &nbsp;
            {schedule.state && (
              <Badge
                count={schedule.state}
                style={{
                  backgroundColor:
                    schedule.state === "active" ? "#52c41a" : "#777",
                }}
              />
            )}
          </h4>

          {isLoadingTest ? (
            <p>
              {this.props.i18n.t("Connection test")} &nbsp;{" "}
              <Icon type="loading" />
            </p>
          ) : test.error || test.status ? (
            <p>
              <Badge
                count={
                  test.error ||
                  `${this.props.i18n.t("Connection")} : ${test.status}`
                }
                style={{ backgroundColor: test.error ? "#f00" : "#52c41a" }}
              />
            </p>
          ) : (
            <div style={{ margin: '0 0 5px' }}>
              <Button size="small" type="primary" onClick={() => { this.getStatus(); }}>
                Test API connection
              </Button>
            </div>
          )}

          {isLoadingData ? (
            <Icon type="loading" />
          ) : (
            <div>
              <Row gutter={12}>
                <Col span={12}>
                  <label>
                    <b>URL</b>
                    <Form.Item>
                      {getFieldDecorator("url", {
                        initialValue: schedule.url,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label style={{ display: "block", width: "170px" }}>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadForm:Scheduled time 1"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("scheduled_time_1", {
                        initialValue: schedule.scheduled_time_1
                          ? moment(schedule.scheduled_time_1, "HH:mm:ss")
                          : null,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<TimePicker />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>Client ID</b>
                    <Form.Item>
                      {getFieldDecorator("client_id", {
                        initialValue: schedule.client_id,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUpload1Form:Client Pass"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("client_pass", {
                        initialValue: schedule.client_pass,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>Client Secret</b>
                    <Form.Item>
                      {getFieldDecorator("client_secret", {
                        initialValue: schedule.client_secret,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.Password />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t("NamespaceScheduleUpload1Form:Server")}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("server", {
                        initialValue: schedule.server,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Username")}</b>
                    <Form.Item>
                      {getFieldDecorator("df_username", {
                        initialValue: schedule.df_username,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Password")}</b>
                    <Form.Item>
                      {getFieldDecorator("df_password", {
                        initialValue: schedule.df_password,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label style={{ display: "block", width: "170px" }}>
                    <b>{this.props.i18n.t("Time Zone")}:</b>
                    <Form.Item>
                      {getFieldDecorator("time_zone", {
                        initialValue: get(schedule, "time_zone", ""),
                      })(
                        <Select
                          showSearch
                          placeholder={this.props.i18n.t("Select")}
                          onChange={this.onChangeTimezone}
                        >
                          <Option value="">{this.props.i18n.t("None")}</Option>
                          {timezones.map(({ utc }) =>
                            utc.map((tz, i) => (
                              <Option value={tz} key={i}>
                                {tz}
                              </Option>
                            ))
                          )}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUploadEcoaForm:Study name"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("study_name", {
                        initialValue: schedule.study_name,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
              </Row>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <div className={classes.actionWrapper}>
                {apiDatafaxCreatePermission && (
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      className={classes.submitButton}
                    >
                      {this.props.i18n.t("Save")}
                      {isLoading && <Icon type="loading" />}
                    </Button>
                    &nbsp; &nbsp;
                  </Form.Item>
                )}

                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.props.onCancel}
                >
                  {this.props.i18n.t("Cancel")}
                </Button>

                {((apiDatafaxDeletePermission && schedule.state === "active") ||
                  (apiDatafaxUpdatePermission &&
                    schedule.state !== "active")) && (
                  <div className={classes.activateWrap}>
                    {this.props.i18n.t("Activate")} &nbsp;
                    <Switch
                      disabled={isLoading}
                      className={classes.activateBtn}
                      checked={schedule.state === "active"}
                      onChange={this.onSwitchActivation(schedule.state)}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  apiDatafaxCreatePermission: getApiDatafaxCreatePermission(state),
  apiDatafaxUpdatePermission: getApiDatafaxUpdatePermission(state),
  apiDatafaxDeletePermission: getApiDatafaxDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "datafaxPullForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DatafaxPullForm))
);



// WEBPACK FOOTER //
// ./src/components/DatafaxForms/DatafaxPullForm.js